"use strict";

var Bookings = function () {

  var trans_mode_change = function(shipment_val) {

    $(".road_ftl_selection").hide();
    $(".selection_trans_mode").show();
    $(".road_selection").hide();
    $(".sea_selection").hide();
    $(".air_selection").hide();
    $(".courier_selection").hide();
    $(".selection_trans_mode").show();
    $("[for=loading_voyage_no]").text("Voyage No");
    $("#bill_of_lading_title").text("Bill of Lading Details");
    $(".loading_waybill_no > label").text("MBL No");
    $(".loading_waybill_date > label").text("MBL Date");
    $(".loading_vagon_no > label").text("House No");
    $('input[type=radio][value="K"][name="loading[load_type]"]').prop('checked', true);
    $('#loading_talex').attr('disabled', 'disabled');
    $('#loading_trans_type').attr('disabled', 'disabled');
    $('.place_inputs').removeClass('col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9').addClass('col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6');

    var trans_mode = $('#loading_trans_mode').val();
    if (trans_mode === undefined) {
      var trans_mode = $('input[type=radio][name="loading[trans_mode]"]:checked').val();
    }
    var load_type = $("#loading_load_type").val()
    if (load_type === undefined) {
      var load_type = $('input[type=radio][name="loading[load_type]"]:checked').val();
    }

    var delivery_input = $('#delivery_input');
    var unloadPlaceFields = $('#unloadPlaceFields');

    switch (trans_mode) {
      case "road":
        $("#loading_load_type").removeAttr("disabled");
        $("#loading_incoterm").removeAttr("disabled");
        $("#loading_load_type").val(shipment_val);
        $('input[type=radio][value="' + shipment_val + '"][name="loading[load_type]"]').prop('checked', true);
        $('#loading_load_type > *[value="K"]').text("FTL");
        $('#loading_load_type > *[value="P"]').text("LTL");
        $('.load_type_k').text("FTL");
        $('.load_type_l').text("LTL");
        $("[for=loading_carrier_id]").text("Haulier / Trucker");
        $(".road_selection").show();
        $(".cargo_ready_date_road").html($(".loading_cargo_ready_date"));
        $(".cargo_ready_date_sea_air > .loading_cargo_ready_date").remove();
        $('.place_inputs').removeClass('col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6').addClass('col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9');
        $('.delivery_input_road').html(delivery_input);
        $('.delivery_input_other').html('');
        $('.trader_place_fields_top').html('');
        $('.trader_place_fields_bottom').html(unloadPlaceFields);

        if (load_type === "K") {
          $(".road_ftl_selection").show();
          var containerName = $("#loading_containers_attributes_0_name").val();
          if (containerName) {
            $("#loading_in_container").val("at_container");
            $('.pack_details').hide();
            $('.container_nested_form').show();
          }
        }
        break;
      case "sea":
        $("#loading_load_type").removeAttr("disabled");
        $("#loading_incoterm").removeAttr("disabled");
        $('#loading_load_type > *[value="K"]').text("FCL");
        $('#loading_load_type > *[value="P"]').text("LCL");
        $('.load_type_k').text("FCL");
        $('.load_type_l').text("LCL");
        $("#loading_load_type").val(shipment_val);
        $('input[type=radio][value="' + shipment_val + '"][name="loading[load_type]"]').prop('checked', true);
        $("[for=loading_carrier_id]").text("Liner");
        $(".sea_selection").show();
        $(".cargo_ready_date_sea_air").html($(".loading_cargo_ready_date"));
        $(".cargo_ready_date_road > .loading_cargo_ready_date").remove();
        $('#loading_talex').removeAttr("disabled");
        $('#loading_load_place_id').attr('data-place-type', 'sea');
        $('#loading_unload_place_id').attr('data-place-type', 'sea');
        $('.delivery_input_road').html('');
        $('.delivery_input_other').html(delivery_input);
        $('.trader_place_fields_top').html(unloadPlaceFields);
        $('.trader_place_fields_bottom').html('');
        $('#loading_load_place_type').val('port').trigger('change');
        $('#loading_unload_place_type').val('port').trigger('change');
        if (load_type === "P") {
          $(".sea_ftl_selection").hide();
        } 
        if (load_type === "K") {
          if ($("#loading_containers_attributes_0_name")) {
            $("#loading_in_container").val("at_container");
            $('.pack_details').hide();
            $('.container_nested_form').show();
          }
        }
        break;
      case "air":
        $("#loading_load_type").attr('disabled', 'disabled');
        $("#loading_incoterm").removeAttr("disabled");
        $('input[type=radio][value="' + shipment_val + '"][name="loading[load_type]"]').prop('checked', true);
        $('input[type=radio][name="loading[trans_mode]"]:checked').val()
        $("[for=loading_carrier_id]").text("Airline");
        $("[for=loading_voyage_no]").text("Flight No");
        $("#bill_of_lading_title").text("AWB Details");
        $(".loading_waybill_no > label").text("AWB NO");
        $(".loading_waybill_date > label").text("AWB Date");
        $(".air_selection").show();
        $(".cargo_ready_date_sea_air").html($(".loading_cargo_ready_date"));
        $(".cargo_ready_date_road > .loading_cargo_ready_date").remove();
        $('#loading_trans_type').removeAttr("disabled");
        $('#loading_load_place_id').attr('data-place-type', 'air');
        $('#loading_unload_place_id').attr('data-place-type', 'air');
        $('.delivery_input_road').html('');
        $('.delivery_input_other').html(delivery_input);
        $('.trader_place_fields_top').html(unloadPlaceFields);
        $('.trader_place_fields_bottom').html('');
        $('#loading_load_place_type').val('port').trigger('change');
        $('#loading_unload_place_type').val('port').trigger('change');
        break;
      case "courier":
        $("#loading_load_type").attr('disabled', 'disabled');
        $('input[type=radio][value="' + shipment_val + '"][name="loading[load_type]"]').prop('checked', true);
        $('input[type=radio][name="loading[trans_mode]"]:checked').val()
        $("#loading_incoterm").attr('disabled', 'disabled');
        $("#loading_incoterm").val('');
        $("[for=loading_carrier_id]").text("Haulier / Trucker");
        $(".courier_selection").show();
        $(".cargo_ready_date_road").html($(".loading_cargo_ready_date"));
        $(".cargo_ready_date_sea_air > .loading_cargo_ready_date").remove();
        $('.delivery_input_road').html('');
        $('.delivery_input_other').html(delivery_input);
        $('.trader_place_fields_top').html(unloadPlaceFields);
        $('.trader_place_fields_bottom').html('');
        $('#loading_load_place_type').val('port').trigger('change');
        $('#loading_unload_place_type').val('port').trigger('change');
        break;
      case "":
        $("[for=loading_carrier_id]").text("Haulier / Trucker");
        $("#loading_load_type").attr('disabled', 'disabled');
        $('input[type=radio][name="loading[trans_mode]"]:checked').val()
        $("#loading_incoterm").attr('disabled', 'disabled');
        $("#loading_incoterm").val('');
        $(".selection_trans_mode").hide();
        $('.delivery_input_other').html(delivery_input);
        $('.delivery_input_road').html('');
        $('.trader_place_fields_top').html(unloadPlaceFields);
        $('.trader_place_fields_bottom').html('');
        break;
    }
  };

  var commodity_type_change = function() {
    const comm_type = $("#loading_commodity_type").val();

    if (comm_type === 'adr') {
      $(".booking_hts_no").show();
      $(".booking_addr_unno").show();
      $(".booking_optimum_temperature").show();
      $(".booking_tag_names").show();
    } else if (comm_type === 'pharma') {
      $(".booking_hts_no").hide();
      $(".booking_addr_unno").hide();
      $(".booking_optimum_temperature").show();
      $(".booking_tag_names").show();
    } else {
      $(".booking_hts_no").hide();
      $(".booking_addr_unno").hide();
      $(".booking_optimum_temperature").hide();
      $(".booking_tag_names").hide();
    }
  };

  var load_type_change = function() {
    $(".road_ftl_selection").hide();

    var trans_mode = $('#loading_trans_mode').val();
    if (trans_mode === undefined) {
      var trans_mode = $('input[type=radio][name="loading[trans_mode]"]:checked').val();
    }
    var load_type = $("#loading_load_type").val()
    if (load_type === undefined) {
      var load_type = $('input[type=radio][name="loading[load_type]"]:checked').val();
    }
    switch(trans_mode){
      case 'road':
        if (load_type == 'P') {
          $(".road_ftl_selection").hide();
          $("#loading_in_container").val('out_of_container').trigger('change');
        } else if (load_type == 'K') {
          $(".road_ftl_selection").show();
          $("#loading_in_container").val('out_of_container').trigger('change');
        }
        break;
      case 'sea':
        if (load_type == 'P') {
          var container_nos = $("#loading_container_nos").val();
          if (container_nos !== undefined && container_nos !== "" ) {
            $("#loading_in_container").val('at_container').trigger('change');
          } else {
            $("#loading_in_container").val('out_of_container').trigger('change');
          }
          $(".sea_ftl_selection").hide();
        } else if (load_type == 'K') {
          $("#loading_in_container").val('at_container').trigger('change');
          $(".sea_ftl_selection").show();
        }
        break;
    }
  };

  var place_type_change = function(place_type) {
    var trans_mode = $('#loading_trans_mode').val();
    if (trans_mode === 'road') {
      var load_place_type = $('#loading_' + place_type +'_place_type').val();
      switch (load_place_type) {
        case "gmaps":
          $('.' + place_type + '_customer_input').hide();
          $('.' + place_type + '_place_input').show();
          $('.' + place_type + '_place_id_input').hide();
          $('#loadPlaceFields').removeClass('show');
          $('[name="loading[' + place_type +'_place]"]').prop('disabled', true)
          $('#loading_' + place_type +'_place').prop('disabled', false)
          break;
        case "customer":
          $('.' + place_type + '_customer_input').show();
          $('.' + place_type + '_place_input').hide();
          $('.' + place_type + '_place_id_input').hide();
          $('#loading_' + place_type + '_place').show();
          $('[name="loading[' + place_type +'_place]"]').prop('disabled', false)
          $('#loading_' + place_type +'_place').prop('disabled', true)
          break;
        case "port":
          $('.' + place_type + '_customer_input').hide();
          $('.' + place_type + '_place_input').hide();
          $('.' + place_type + '_place_id_input').show();
          $('#loadPlaceFields').removeClass('show');
          $('[name="loading[' + place_type +'_place]"]').prop('disabled', true)
          break;
        }
    }
  };

  var unit_type_label_changes = function() {
    var containerWeight = $("#loading_weight_unit").is(":checked") ? "LB" : "KG";
    
    $(".loading_containers_weight label").each(function() {
      var text = $(this).text();
      var newText = text.replace(/KG|LB/g, containerWeight);
      $(this).text(newText);
    });
    
  };

  return {
    init: function (val) {
      $(document).on("change", '[name="loading[trans_mode]"]', function () {
        $("#loading_load_type").val(null);
        trans_mode_change("");
      });


      $(document).on('change', '[name="loading[load_type]"]', function() {
        load_type_change();
      });

      var shipment_val = $("#loading_load_type").val();
      if ((shipment_val === undefined) || (shipment_val === '')) {
        var shipment_val = $('input[type=radio][name="loading[load_type]"]:checked').val();
      }
      trans_mode_change(shipment_val);

      $(document).on("change", "#loading_commodity_type", function (event) {
        commodity_type_change();
      });
      commodity_type_change();

      $(".loading_vagon_no").addClass("d-block");

      $(document).on("change", "#loading_load_place_type", function (event) {
        place_type_change("load");
      });
      place_type_change("load");

      $(document).on("change", "#loading_unload_place_type", function (event) {
        place_type_change("unload");
      });
      place_type_change("unload");

      $(document).on("change", "#loading_weight_unit", function (event) {
        unit_type_label_changes();
      });
      $(document).on("click", '[data-behaviour="add_containers"]', function () {
        unit_type_label_changes();
      });
      unit_type_label_changes();
    },
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Bookings;
}